import React from 'react'
import { NavLink } from 'react-router-dom'
import logo from './image/Logo.png'
const RefundPolicy = () => {
  return (
    <div>
         <div className='container-fluid py-2   bg-white position-sticky top-0' style={{ boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.2)', zIndex:'999',marginTop:'-26px'}}>
        <div className='row' >
                <div className='col-10'>
                <NavLink to="/home">  <img src={logo}  style={{width:'50px'}}/></NavLink>
                </div>
                <div className='col-2'>
                   <NavLink to="/"> <button className='btn text-primary ' style={{border:'1px solid gray'}}>Login</button></NavLink>
                </div>
            </div>
        </div>

        <div className='container mt-5'>
            <div className='row'>
                <div className='col-lg-12'>
                <nav aria-label="breadcrumb" >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/home">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                Refund Policy 
                </li>
              </ol>
            </nav>

            <div>


                <h2>Refund Policy</h2>
                </div>

<p className='my-4 '  style={{fontSize:'14px'}}> 

Thanks for being a patron with (referred as BrothersLudo)  . If you are not entirely satisfied with your subscription, we are here to help.</p>


<p>Refund</p>

<p style={{fontSize:'14px'}}>Once we receive your Refund request, we will inspect it and notify you on the status of your refund.</p>

<p style={{fontSize:'14px'}}>If your refund request is approved, we will initiate a refund to your credit card (or original method of payment) within 7 working days. You will receive the credit within a certain amount of days, depending on your card issuer's policies.</p>

<p style={{fontSize:'14px'}}>In case of unforeseen technical glitch, would refund subscription upon reviewing the complaint. Final decision lies with the company.</p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default RefundPolicy